import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useState } from "react"

import { replaceRichTextLinks } from "utils"
import ReactPlayerComponent from "../Homepage/Hero/ReactPlayer"
import { TabItemType } from "./TabsContent"

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 800px;
    gap: 48px;
  }
`

const StyledItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
  }
`
const BoxText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledTypography = styled(Typography)<{ component?: string }>`
  p {
    margin: 0;
  }
  table {
    max-width: 100%;
    overflow-x: auto;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 230px;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.up("md")} {
    height: 400px;
  }
`
export default function TabItem({ data }: { data: TabItemType }) {
  const [volume, setVolume] = useState(true)
  const [playing, setPlaying] = useState(false)
  return (
    <StyledContainer>
      {data.map((el, i) => (
        <StyledItem key={i}>
          <BoxText>
            <Typography variant="h2">{el.subTitle}</Typography>
            <StyledTypography
              variant="body1"
              component="div"
              dangerouslySetInnerHTML={{
                __html: replaceRichTextLinks(el.content),
              }}
            />
          </BoxText>

          {el.media && (
            <ImageContainer>
              <ReactPlayerComponent
                setPlaying={setPlaying}
                setVolume={setVolume}
                source={el.media}
                playing={playing}
                volume={volume}
              />
            </ImageContainer>
          )}
        </StyledItem>
      ))}
    </StyledContainer>
  )
}
